import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=31f56515&"
import script from "./ImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports